export default (d: Date, format: string): string => {
    let datestring: string = '';

    switch (format) {
        case 'Y-m-d':
            datestring = `${d.getFullYear()}-${`0${d.getMonth() + 1}`.slice(-2)}-${`0${d.getDate()}`.slice(-2)}`;
            break;
        case 'Y-m-d h:i:s':
            datestring = `${d.getFullYear()}-${`0${d.getMonth() + 1}`.slice(-2)}-${`0${d.getDate()}`.slice(
                -2
            )} ${`0${d.getHours()}`.slice(-2)}:${`0${d.getMinutes()}`.slice(-2)}:${`0${d.getSeconds()}`.slice(-2)}`;
            break;
        default:
            throw new Error('Date format not valid for the filter');
    }

    return datestring;
};
